import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../extras/ProtectedRoute';
import FreeUsersPage from './page';
import EnrolledUsersPage from './enrolled-page';
import EnrolmentFinancialPage from './enrolment-financial-page';
import UserDetails from './user-details/page';
import EnrollPayment from './enroll-payment/page';

export default function AllUsersRouter() {
  return (
    <Switch>
      <ProtectedRoute exact path='/all-users' component={FreeUsersPage} />
      <ProtectedRoute exact path='/all-users/enrolled' component={EnrolledUsersPage} />
      <ProtectedRoute exact path='/all-users/enrolment-financial' component={EnrolmentFinancialPage} />
      <ProtectedRoute exact path='/all-users/user-details' component={UserDetails} />
      <ProtectedRoute exact path='/all-users/enroll-payment' component={EnrollPayment} />
    </Switch>
  );
}
